// extracted by mini-css-extract-plugin
export default {"Tags":"styles_Tags__l4TGn"};